import { observer } from "mobx-react";
import { Button } from "primereact/button";
import { TabMenu, TabMenuTabChangeParams } from "primereact/tabmenu";
import { Toolbar } from "primereact/toolbar";
import { useContext } from "react";
import { useHistory } from "react-router";
import { logout } from "../../api/firebase/auth";
import { screenSize, useMediaQuery } from "../../hooks/responsiveLayout";
import { navItems } from "../../navigation/NavItems";
import SessionStore from "../../store/SessionStore";
import { Container } from "../container";
import NavigationContext from "../pageLayout/NavgationContext";
import SettingsButton from "./settingsMenu/SettingsButton";
import SidebarMenu from "./SidebarMenu";

export const HeaderToolbar: React.FC = () => {
  const [width] = useMediaQuery();
  const history = useHistory();

  const { activeNavItem, setActiveNavItem } = useContext(NavigationContext);
  const onTabChange = (evt: TabMenuTabChangeParams) => {
    evt.originalEvent.preventDefault();
    const newNavItem = navItems[evt.index];
    setActiveNavItem(newNavItem);
    history.push(newNavItem.url);
  };

  const showMenu = () => {
    if (!SessionStore.user) return null;
    if (width >= screenSize.desktop)
      return (
        <TabMenu
          className="header-tabmenu"
          model={navItems}
          activeIndex={activeNavItem.index}
          onTabChange={onTabChange}
        />
      );
    return <SidebarMenu />;
  };

  const showRightButtons = () => {
    if (!SessionStore.user) return null;
    return [
      <SettingsButton key="settings-button" />,
      <Button
        label="Logout"
        key="logout-button"
        className="p-button-outlined"
        icon="pi pi-power-off"
        onClick={logout}
      />,
    ];
  };

  return (
    <Container flexDirection="row" containerClassName="header-toolbar">
      <Toolbar left={showMenu()} right={showRightButtons()} />
    </Container>
  );
};

export default observer(HeaderToolbar);
